import React from 'react';
import { BrowserRouter as Router, Route, Switch, routerRedux, Redirect } from 'dva/router';
import App from './routes/app';
import { ASSIGN_MODE, EDIT_MODE, storageToken } from './utils/constant';

// Pages Route Imports
import Login from './routes/Login/index';
import Signup from './routes/Signup/index';
import ForgotPassword from './routes/ForgotPassword/index';
import ResetPassword from './routes/ResetPassword/index';
import Subscription from './routes/Subscription/index';
import Four04 from './routes/Four04/index';

// Guarded Routes Imports
import UsersManagement from './routes/UserManagement/index';
import AccountDirectorManagement from './routes/AccountDirectorManagement/index';
import ViewProfile from './routes/UserManagement/ViewProfile/index';
import ViewCompany from './routes/CompanyManagement/ViewCompany/index';
import CompanyManagement from './routes/CompanyManagement/index';
import DepartmentManagement from './routes/DepartmentManagement/index';
import Reports from './routes/Reports/index';

import RequestForms from './routes/RequestForms/index';
import CreateRequestForm from './routes/RequestForms/CreateRequestForm/index';
import EditRequestForm from './routes/RequestForms/EditRequestForm/index';

import Dashboard from './routes/Dashboard/index';
import MakeRequest from './routes/MakeRequest/index';
import ReviewRequest from './routes/ReviewRequest/index';
import RequestManagement from './routes/RequestManagement/index';
import Profile from './routes/Profile/index';


const { ConnectedRouter } = routerRedux;

const registerModel = (app, model) => {
  if (!(app._models.filter((m) => m.namespace === model.namespace).length === 1)) {
    app.model(model);
  }
};

const PrivateRoute = (props) => {
  const AuthToken = localStorage.getItem(`${storageToken}`);
  if (AuthToken) {
    return <Route {...props} />;
  } else {
    return <Redirect to={{ pathname: '/' }} />;
  }
};

const openRoutes = [
  '/',
  '/login',
  '/signup',
  '/forgotpassword',
  '/auth/reset-password',
  '/subscription',
  '/404',
];

export function RouterConfig({ history, app }) {
  return (
    <ConnectedRouter history={history}>
      <App openRoutes={openRoutes} history={history}>
        <Switch>
          {/* #########   S T A R T :   O P E N      U R L S   #########*/}
          <Route path="/" exact render={(props) => <Login {...props} />} />
          <Route path="/forgotpassword" exact render={(props) => <ForgotPassword {...props} />} />
          <Route
            path="/auth/reset-password"
            exact
            render={(props) => <ResetPassword {...props} />}
          />
          <Route path="/signup" exact render={(props) => <Signup {...props} />} />
          <Route path="/subscription" exact render={(props) => <Subscription {...props} />} />
          {/* #########   E N D :    O P E N      U R L S   #########*/}
          {/* #########   S T A R T :   G U A R D E D      U R L S   #########*/}

          <PrivateRoute path="/users" exact render={(props) => <UsersManagement {...props} />} />
          
          <PrivateRoute path="/directors" exact render={(props) => <AccountDirectorManagement {...props} />} />
          <PrivateRoute
            path="/companies"
            exact
            render={(props) => <CompanyManagement {...props} />}
          />
          <PrivateRoute
            path="/departments"
            exact
            render={(props) => <DepartmentManagement {...props} />}
          />
          <PrivateRoute path="/profile" exact render={(props) => <Profile {...props} />} />
          <PrivateRoute path="/reports" exact render={(props) => <Reports {...props} />} />
          <PrivateRoute
            path="/users/profile"
            exact
            render={(props) => <ViewProfile {...props} />}
          />
          <PrivateRoute
            path="/companies/profile"
            exact
            render={(props) => <ViewCompany {...props} />}
          />

          <PrivateRoute path="/requests" exact render={(props) => <RequestForms {...props} />} />
          <PrivateRoute
            path="/requests/create"
            exact
            render={(props) => <CreateRequestForm {...props} />}
          />
           <PrivateRoute
            path="/requests/edit"
            exact
            render={(props) => <EditRequestForm {...props} />}
          />
          
          <PrivateRoute
            path="/applications"
            exact
            render={(props) => <RequestManagement {...props} />}
          />
          <PrivateRoute
            path="/requests/make"
            exact
            render={(props) => <MakeRequest {...props} />}
          />
          <PrivateRoute
            path="/requests/review/:id"
            exact
            render={(props) => <ReviewRequest {...props} />}
          />
          <PrivateRoute path="/dashboard" exact render={(props) => <Dashboard {...props} />} />

          {/* #########   E N D :    G U A R D E D      U R L S   #########*/}
          <Route path="/404" exact render={(props) => <Four04 {...props} />} />
          <Route
            render={(props) => {
              return <Redirect to={{ pathname: "/404" }} />;
            }}
          />
        </Switch>
      </App>
    </ConnectedRouter>
  );
}
